module.exports = __webpack_public_path__ + "static/Skyflow-aa049d61b9ed4ff2db9a81242332557a.jpg";